import { pushAPI } from '../api';

const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) output[i] = raw.charCodeAt(i);
  return output;
};

export const isPushSupported = () =>
  'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

export const getPushStatus = async () => {
  if (!isPushSupported()) return { supported: false, subscribed: false, permission: 'unsupported' };
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return { supported: true, subscribed: !!sub, permission: Notification.permission };
  } catch (e) {
    return { supported: true, subscribed: false, permission: Notification.permission };
  }
};

export const subscribeToPush = async () => {
  if (!isPushSupported()) throw new Error('Push not supported on this device/browser');
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Notification permission denied');

  const { data } = await pushAPI.getPublicKey();
  if (!data.enabled || !data.public_key) throw new Error('Push not configured on the server');

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
  }
  const json = sub.toJSON();
  await pushAPI.subscribe({ endpoint: json.endpoint, keys: json.keys });
  return true;
};

export const unsubscribeFromPush = async () => {
  if (!isPushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    const json = sub.toJSON();
    try { await pushAPI.unsubscribe({ endpoint: json.endpoint, keys: json.keys || {} }); } catch (e) { /* ignore */ }
    await sub.unsubscribe();
  }
};
